// Full-document render of the sealy ProductPage: PageSkeleton (the React
// document shell) wrapping the existing product-page body assembly (including
// its ProductGridSSR envelopes, which serialize inside the body pick).
import React from "react";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";
import { ProductPageBody } from "../components/ProductPageBody";

// Mutable reactivated props (not Immutable<>): this template composes the
// in-tree SiteHeader/RichNavigation chain via PageSkeleton, which is typed
// with mutable reactivated props (see PageSkeleton). The body template accepts
// Immutable props, to which these are assignable.
export const Template = (
    props: templates.ProductPageTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <ProductPageBody page={props.page} />
    </PageSkeleton>
);
